import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { DualRing } from "react-loading-io";
import {
  comboValidator,
  validatorFieldPrimaUltraCash,
} from "../Utils/validators";
import ErrorCustom from "./errorCustom";
import { useSelector } from "react-redux";
import DetailsTab from "./detailsTab";
import TitleQuoteForm from "./titleQuoteForm";
import BoxNumber from "./boxNumber";
import alert from "../Resources/img/icon-alert-yellow.png";
import AlertMessage from "./alertMessage";
import RadioButtonsDps from "./radioButtonsDps";
import RadioButtonsMoneyHooks from "./RadioButtonsMoneyHooks";
import YearComponents from "./yearComponents";

const HookFormUc = ({
  submitValues,
  listPortafolios,
  dataState,
  investmentProfile,
  investmentPortfolio,
  onClick,
  isError,
  apiError,
  setSimbolo,
  setState,
}) => {
  const { handleSubmit, register, errors, setValue, watch } = useForm();
  const [loading, setLoading] = useState(false);
  const [verifyMoney, setVerifyMoney] = useState("USD");
  const [checked, setChecked] = useState(false);
  const [dps, setDps] = useState(false);
  const [selectYEar, setSelectYEar] = useState([]);
  const monedaText = verifyMoney === "USD" ? "dólares" : "Soles";
  const [defaultValue, setDefaultValue] = useState(5000);
  const channel = useSelector((state) => state.login.channel);

  const onSubmit = (values) => {
    const data = {
      ...values,
      channel,
    };
    submitValues(data);
  };

  useEffect(() => {
    setSimbolo(verifyMoney);
  }, [verifyMoney]);

  const { codigoPortafolio } = watch();

  const filterPortafolios = listPortafolios
    .map((el) => el.portafolios)
    .filter((el) => el[0].moneda === verifyMoney);

  const { indActivo } = listPortafolios.length && listPortafolios[1];

  const filterYear = listPortafolios.filter((element) =>
    element.portafolios[0].codigo.includes(codigoPortafolio)
  );

  useEffect(() => {
    if (filterYear.length !== 0) {
      const { duracionPoliza } = filterYear[0].portafolios[0];
      setSelectYEar(duracionPoliza);
    }
  }, [codigoPortafolio]);

  useEffect(() => {
    const initValue = verifyMoney === "USD" ? 5000 : 15000;
    setDefaultValue(initValue);
  }, [verifyMoney]);

  return (
    <div className="vasForm product-ig">
      <TitleQuoteForm
        title="Inversión Global Ultra Cash"
        subtitle="Obtén la cotización en unos minutos"
      />

      <DetailsTab
        dataState={dataState}
        list={true}
        onClick={onClick}
        customerProfile={investmentProfile}
        investmentPortfolio={investmentPortfolio}
      />

      <form onSubmit={handleSubmit(onSubmit)} className="vasForm__form">
        <div className="vasForm__form__input-container">
          {indActivo && (
            <>
              <label>Capital en {monedaText}</label>
              <RadioButtonsMoneyHooks
                register={register}
                name="money_uc"
                setVerifyMoney={setVerifyMoney}
                enableMoneyPEN={true}
                setState={setState}
              />
            </>
          )}
          <BoxNumber
            setValue={setValue}
            register={register}
            initCounter={defaultValue}
            nameVal="capital"
            verifyMoney={verifyMoney}
            incrementValue={1000}
            validatorInput={validatorFieldPrimaUltraCash}
          />
          <ErrorCustom errors={errors} name="capital" />
        </div>

        <div className="vasForm__form__input-container-select">
          <label>Portafolio</label>
          <select
            id="codigoPortafolio"
            name="codigoPortafolio"
            ref={register({ validate: comboValidator })}
            disabled={true}
          >
            {listPortafolios.length &&
              filterPortafolios[0].map(({ codigo, descripcion }, idx) => (
                <option key={idx} value={codigo}>
                  {descripcion}
                </option>
              ))}
          </select>
          <ErrorCustom errors={errors} name="codigoPortafolio" />
        </div>

        <div className="vasForm__form__input-container">
          <div className="year-box">
            <label>Años temporal</label>
            <YearComponents register={register} selectYEar={selectYEar} comboValidator={comboValidator} errors={errors}/>
          </div>
        </div>

        <div className="vasForm__form__input-container-dps-counter__portafolio">
          <label>¿El asegurado cuenta con DPS afirmativa?</label>
          <div className="vasForm__form__input-container-dps-counter__portafolio__container">
            <RadioButtonsDps
              name="dpsAfirma"
              register={register}
              setDps={setDps}
              setChecked={setChecked}
              id="uc"
            />
          </div>
        </div>
        {isError && (
          <div className="vasForm__form__btn-container">
            <AlertMessage
              background="#FFEFD8"
              icono={alert}
              mensaje="Llegaste al límite máximo de cotizaciones, limpia la tabla de cotizaciones para crear una nueva cotización."
            />
          </div>
        )}
        {apiError && (
          <div className="vasForm__form__btn-container">
            <AlertMessage
              background="#FFEFD8"
              icono={alert}
              mensaje={apiError}
            />
          </div>
        )}
        <div className="vasForm__form__btnew-group">
          <button id="button_quote_vas" type="submit" className="btn btnew">
            Cotizar
          </button>
        </div>
      </form>
      {loading && (
        <div className="loading-field">
          <DualRing size={50} />
        </div>
      )}
    </div>
  );
};

export default HookFormUc;
